<template>
  <div>
    <v-data-table
        :headers="carsTableHeader"
        :items="list"
        class="elevation-0 mb-3"
        :footer-props="{
        'items-per-page-text': $t('tables.items_per_page'),
        'items-per-page-options': [
          10, 50, 100,
          //-1
        ],
      }"
    >
      <template v-slot:footer.page-text="props">
        {{
          $t("tables.x_of_y", [
            `${props.pageStart}-${props.pageStop}`,
            props.itemsLength,
          ])
        }}
      </template>
      <template v-slot:item="props">
        <tr>
          <td class="text-xs-left">
            <v-btn
                class="ma-2 ml-0"
                elevation="0"
                color="success"
                @click="$emit('selected', props.item)"
            >
              {{ $t("common.select") }}
            </v-btn>
          </td>
          <td class="text-xs-center">
            <img
                :src="props.item.image ? props.item.image : $imgDummyPath"
                height="35px"
            />
          </td>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="text-xs-left">
            <beauty-car-number
                :number="props.item.car_number ? props.item.car_number : ''"
            />
          </td>
          <td class="text-xs-left">
            {{ props.item.brand }}
          </td>
          <td class="text-xs-left">
            {{ props.item.family }}
          </td>
          <td class="text-xs-left">
            {{ props.item.model }}
          </td>
          <td class="text-xs-left">
            {{ props.item.vin }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ $t("common.no_data_available") }}
      </template>
      <template v-slot:no-results>
        {{ $t("common.no_data_available") }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import CarForm from "@/components/garage/CarForm.vue";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import MaintenanceParts from "@/components/garage/MaintenanceParts.vue";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";

export default {
  name: "CarSelectorFromList",
  components: { BeautyCarNumber, CarForm, MaintenanceParts },
  mixins: [CommonMixin],
  props: {
    list: Array,
  },
  data: () => ({

  }),
  computed:{
    carsTableHeader() {
      return [
        {
          text: this.$t("common.select"),
          value: "name",
          sortable: false,
        },
        {
          text: '',
          value: "image",
          sortable: false,
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.car_number"),
          value: "car_number",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.brand"),
          value: "brand",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.family"),
          value: "family",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.model"),
          value: "model",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("VIN"),
          value: "vin",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.actions"),
          value: "vin",
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
  },
  methods: {

  },
};
</script>
